import { ILossPreventionConfig } from '../useLossPreventionConfig'

export const timoneyBkConfig: ILossPreventionConfig = {
  summary: {
    isVisible: true,
  },
  kpiSettings: [
    { category: 'basic', key: 'totalComps', title: 'Total Discounts' },
    { category: 'basic', key: 'cashOverOrShort', title: 'Cash +/-' },
    {
      category: 'custom',
      type: 'Over Ring',
      title: '% Checks with Over Ring',
      key: 'checkPercent',
    },
    {
      category: 'custom',
      type: 'Deal after Total',
      title: '% Checks with Deletes',
      key: 'checkPercent',
    },
  ],
  cashHandlingTable: {
    display: true,
    columns: [
      {
        key: 'Over Ring',
        title: 'Over Ring',
        children: [
          {
            key: 'Over Ring.count',
            title: '#',
            valueType: 'count',
            width: '75px',
            sorter: true,
          },
          {
            key: 'Over Ring.amount',
            title: '$',
            valueType: 'price',
            width: '75px',
            sorter: true,
          },
        ],
      },
      {
        key: 'Deal after Total',
        title: 'Deletes',
        children: [
          {
            key: 'Deal after Total.count',
            title: '#',
            valueType: 'count',
            width: '75px',
            sorter: true,
          },
          {
            key: 'Deal after Total.amount',
            title: '$',
            valueType: 'price',
            width: '75px',
            sorter: true,
          },
        ],
      },
    ],
  },
  voidsAndDeletesTable: {
    display: false,
    columns: [],
  },
  discountByEmployeeTable: {
    display: false,
  },
  opsCompsBreakdownTable: {
    display: false,
  },
}
